var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('svg',{staticClass:"circle-progress"},[_c('circle',{staticClass:"bg",attrs:{"cx":"12","cy":"12","r":"9"}}),_c('circle',{staticClass:"progress",attrs:{"cx":"12","cy":"12","r":"9"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }